import {
  ChatTranslations,
  chatTranslations,
} from '@/assets/locales/util/chat/chat.translations.pl.ts';
import {
  ToastsTranslations,
  toastsTranslations,
} from '@/assets/locales/util/toasts/toasts.translations.pl.ts';
import {
  yearsMonthsTranslation,
  YearsMonthsTranslation,
} from '@/assets/locales/util/yearsMonths/yearsMonths.translation.pl.ts';

export type UtilsTranslation = {
  actionRequired: string;
  chat: ChatTranslations;
  toasts: ToastsTranslations;
  yearsMonths: YearsMonthsTranslation;
};

export const utilsTranslation: UtilsTranslation = {
  actionRequired: 'Wymagana akcja!',
  chat: chatTranslations,
  toasts: toastsTranslations,
  yearsMonths: yearsMonthsTranslation,
};
